// @ts-strict-ignore
import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';
import Helmet from 'react-helmet';
import { UserContext } from '~/dashboard/context';
import type {
  AgentProps, CustomerProps, ITitleContext, PageTitleProviderProps,
} from './constants';
import { calculateTitle } from './helpers';

const defaultTitle = 'Alloy: Identity Risk Solution for Financial Services';

const initialTitle = {
  prefix: defaultTitle,
  rowCount: -1,
  setTitlePrefix: () => {},
  setTitleRowCount: () => {},
};

export const TitleContext = createContext<ITitleContext>(initialTitle);
export const useTitleContext = () => useContext(TitleContext);

export default function PageTitleProvider({ children }: PageTitleProviderProps) {
  const [title, setTitle] = useState(defaultTitle);
  const [prefix, setTitlePrefix] = useState('');
  const [rowCount, setTitleRowCount] = useState(-1);
  const {
    agent,
    customer,
  } = useContext(UserContext);

  useEffect(() => {
    const newTitle = calculateTitle(
      prefix, rowCount, agent as AgentProps, customer as CustomerProps,
    );
    setTitle(newTitle);
  }, [agent, customer, prefix, rowCount]);

  const resetToDefault = () => {
    setTitlePrefix('');
    setTitleRowCount(-1);
  };

  const value = useMemo(() => ({ // react/jsx-no-constructed-context-values
    rowCount,
    prefix,
    setTitlePrefix,
    setTitleRowCount,
    resetToDefault,
  }), [rowCount, prefix, setTitlePrefix, setTitleRowCount]);

  return (
    <TitleContext.Provider
      value={value}
    >
      <Helmet defer={false}>
        <title>{title}</title>
      </Helmet>
      {children}
    </TitleContext.Provider>
  );
}
